var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAntiquityIcon = function SvgAntiquityIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.148 5.5a.5.5 0 0 0 1 0V5h5.222v.5a.5.5 0 0 0 1 0V5h2.112a.5.5 0 0 1 .5.5V7H4.019V5.498c0-.275.222-.498.5-.498h1.63zm1-1.5h5.222v-.5a.5.5 0 0 1 1 0V4h2.112a1.5 1.5 0 0 1 1.5 1.5v4a.5.5 0 1 1-1 0V8H4.019v7a.5.5 0 0 0 .5.5h2.63a.5.5 0 0 1 0 1h-2.63a1.5 1.5 0 0 1-1.5-1.5V5.498c0-.83.672-1.498 1.5-1.498h1.63v-.5a.5.5 0 0 1 1 0zm8.179 8.109a.5.5 0 0 0-.653 0l-2.682 2.312a.5.5 0 0 1 .008.089v4.988a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5V14.51q0-.045.008-.09zm-5.5 4.179L11 15.276v4.222a1.5 1.5 0 0 0 1.5 1.5h5a1.5 1.5 0 0 0 1.5-1.5v-4.222l1.174 1.012a.5.5 0 0 0 .652-.758l-4.847-4.179a1.5 1.5 0 0 0-1.958 0l-4.847 4.18a.5.5 0 0 0 .652.757",
    clipRule: "evenodd"
  })));
};
export default SvgAntiquityIcon;